export const constants = {
	selector: {
		target: 'data-tooltip',
		placement: 'data-tooltip-placement',
	},
}
